<p-slider
  *ngIf="visible"
  [(ngModel)]="value"
  [min]="min"
  [max]="max"
  (ngModelChange)="handleModelChange($event)"
  (onChange)="handleOnChange($event.value!);"
  (onSlideEnd)="handleOnSlideEnd($event.value!)"
  [disabled]="disabled"
></p-slider>
